/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Link} from 'react-router-dom'

type Props = {
  className: string
  items: Item[]
  title?: string
  subtitle?: string
  componentLink?: any
}

type Item = {
  icon?: string
  title: string
  subtitle?: string
  content?: string
  logo?: string
  badgeClassName?: string
  link?: string
}

const DashboardCard: React.FC<Props> = ({className, items, title, subtitle, componentLink}) => {
  return (
    <div className={className}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder text-dark'>{title}</span>
          <span className='text-muted mt-1 fw-bold fs-7'>{subtitle}</span>
        </h3>
      </div>
      <div className='card-body pt-5'>
        {items.map((item, index) => (
          <div key={index} className='d-flex align-items-sm-center mb-7'>
            {item.logo && (
              <div className='symbol symbol-50px me-5'>
                <span className='symbol-label'>
                  <img src={item.logo} className='h-100 align-self-center border radius-5' alt='' />
                </span>
              </div>
            )}
            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
              <div className='flex-grow-1 me-2'>
                {!item.link ? (
                  <span className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                    {item.title}
                  </span>
                ) : (
                  <Link
                    to={item.link || ''}
                    className={`text-gray-800 text-hover-primary fs-6 fw-bolder`}
                  >
                    {item.title}
                  </Link>
                )}
                {item.subtitle && (
                  <span className='text-muted fw-bold d-block fs-7'>{item.subtitle}</span>
                )}
              </div>
              {!item.link ? (
                <span
                  className={`badge fw-bolder my-2 fs-6 ${item.badgeClassName ?? 'badge-light'}`}
                >
                  {item.content}
                </span>
              ) : (
                <Link
                  to={item.link || ''}
                  className={`badge fw-bolder my-2 fs-6 ${item.badgeClassName ?? 'badge-light'}`}
                >
                  {item.content}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
      {componentLink && (
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <Link to={componentLink.to} className='btn btn-primary'>
            {componentLink.text}
          </Link>
        </div>
      )}
    </div>
  )
}

export {DashboardCard}
